import { render, staticRenderFns } from "./secure-docs.vue?vue&type=template&id=3082b745&scoped=true"
import script from "./secure-docs.vue?vue&type=script&lang=js"
export * from "./secure-docs.vue?vue&type=script&lang=js"
import style0 from "./secure-docs.vue?vue&type=style&index=0&id=3082b745&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3082b745",
  null
  
)

export default component.exports